module.exports = __webpack_public_path__ + "img/editor.e136db10.svg";